export default {
  headerTitle: "Decline Pending Request",
  headerDescription:
    "Please enter a note to your client explaining your reason for decline. This message will appear in an email sent to the client on your behalf.",
};
